import { TAG_CODES } from "../../tag.config"

const GOM_SECTOR_FUNCTIONAL = {
    type: 'sectorFunctional',
    tagCode: TAG_CODES.SECTOR,
    withText: true,
    defaultText: 'Functional sector',
    positionText: 'top', // top - right - center - bottom - left
    fieldsText: ["title"],
    endTextWidthStr: "",
    angle: 0,
    colorCodeId: 'water',
    withFillColor: true,
    schema: {
        "type": 'object',
        "properties": {
            "title": {
                "title": "Text",
                "description": "Write a text",
                "type": "string",
            },
        },
        "required": []
    },
}

export default GOM_SECTOR_FUNCTIONAL